import { proxy } from 'valtio'

const state = proxy({
  colors: [
    '#0A0A0A', // Nero Noctis (Gloss Black)
    '#FFD700', // Giallo Orion (Gold Yellow)
    '#CC0000', // Rosso Mars (Bright Red)
    '#ffffff', // Bianco Isis (Pure White)
    '#FF6F00', // Arancio Borealis (Vibrant Orange)
    '#006E6D', // Blu Cepheus (Light Blue)
    '#8B00FF', // Viola Parsifae (Deep Purple)
    '#85C1E9', // Blu Caelum (Light Sky Blue)
  ],
  selectedColor: '#85C1E9',
})

export { state }
